const audioModule = {
  state: {
    playState: {
      playing: false,
      trackId: null,
      audioPlayerId: null
    },
    audioPlaybackRate: 1,
    audioPlaybackRates: [0.5, 1, 1.5, 2],
    audioVolume: 100
  },

  mutations: {
    setPlayState (state, payload) {
      state.playState = payload
    },
    setAudioPlaybackRate (state, payload) {
      state.audioPlaybackRate = payload
    },
    setAudioVolume (state, payload) {
      state.audioVolume = payload
    }
  },

  actions: {
    setPlayStatePlaying (context, payload) {
      context.commit('setPlayState', {
        ...context.state.playState,
        playing: payload
      })
    },
    setPlayStateTrackId (context, payload) {
      context.commit('setPlayState', {
        ...context.state.playState,
        trackId: payload
      })
    },
    setPlayStateAudioPlayerId (context, payload) {
      context.commit('setPlayState', {
        ...context.state.playState,
        audioPlayerId: payload
      })
    },
    setAudioPlaybackRate (context, payload) {
      context.commit('setAudioPlaybackRate', payload)
    },
    setAudioVolume (context, payload) {
      context.commit('setAudioVolume', payload)
    }
  },

  getters: {
    playStatePlaying: state => state.playState.playing,
    playStateTrackId: state => state.playState.trackId,
    playStateAudioPlayerId: state => state.playState.audioPlayerId
  }
}

export default audioModule
